import { ReactNode } from 'react';
import { Stack } from '@optimus-web/core';

interface Props {
    title: ReactNode;
    actions: ReactNode;
    children: ReactNode;
}

export const Section = ({ title, actions, children }: Props) => (
    <Stack vertical spacing="400">
        <Stack distribution="space-between">
            <div>{title}</div>
            <div>{actions}</div>
        </Stack>
        {children}
    </Stack>
);
